import React, { useState } from "react";
import { createTicketValidation } from "../../Constant/constant";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import Spinner from "../../Layouts/Spinner";
import { createNewTicket } from "../../../redux/tickets/actions";

const CreateTicket = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      title: "",
      status: 0,
      position: "",
      ar_title: "",
    },
    validationSchema: createTicketValidation,
    onSubmit: (values) => {
      handleSubmit(values);
    },
  });

  const handleSubmit = async (values) => {
    const data = {
      ...values,
    };
    dispatch(createNewTicket(data, setLoading, navigate));
  };

  const handleChangeStatus = (e) => {
    const gender = e.target.value;
    formik.setFieldValue("status", Number(gender));
  };

  const handleChangePosition = (e) => {
    const pos = e.target.value;
    formik.setFieldValue("position", Number(pos));
  };

  return (
    <div className="px-3">
      <div className=" category-wrapper">
        <h3 className="pb-3">Create Query Topic</h3>
        <form onSubmit={formik.handleSubmit}>
          <div className="row ">
            <div className="col-md-4 form-group">
              <label>Title</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter query title"
                name="title"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.title}
              />
              {formik.touched.title && formik.errors.title ? (
                <div className="error">{formik.errors.title}</div>
              ) : null}
            </div>

            <div className="col-md-4 form-group">
              <label>Ar Title</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter ar query title"
                name="ar_title"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.ar_title}
              />
              {formik.touched.ar_title && formik.errors.ar_title ? (
                <div className="error">{formik.errors.ar_title}</div>
              ) : null}
            </div>

            <div className="form-group col-md-4">
              <label htmlFor="status">Position</label>
              <select
                id="position"
                title="position"
                className="form-control"
                onChange={handleChangePosition}
                onBlur={formik.handleBlur}
                value={formik.values.position}
              >
                <option value="">Select Position</option>
                {[...Array(50)].map((_, index) => (
                  <option key={index + 1} value={index + 1}>
                    {index + 1}
                  </option>
                ))}
              </select>
              {formik.touched.position && formik.errors.position ? (
                <div className="error">{formik.errors.position}</div>
              ) : null}
            </div>

            <div className="form-group col-md-4">
              <label htmlFor="status">Status</label>
              <select
                id="status"
                title="status"
                className="form-control"
                onChange={handleChangeStatus}
                onBlur={formik.handleBlur}
                value={formik.values.status}
              >
                <option value="">Select Status</option>
                <option value="1">Active</option>
                <option value="2">Inactive</option>
              </select>
              {formik.touched.status && formik.errors.status ? (
                <div className="error">{formik.errors.status}</div>
              ) : null}
            </div>
          </div>
          <div
            className="d-flex align-items-center justify-content-center mt-3  "
            style={{ columnGap: "20px" }}
          >
            <button
              type="button"
              className="submit-btn  "
              onClick={() => {
                navigate(-1);
              }}
              style={{ width: "max-content" }}
            >
              Back
            </button>
            <button
              className="submit-btn   "
              style={{ width: "max-content" }}
              type="submit"
            >
              {!loading ? "Submit" : <Spinner />}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateTicket;
